/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import theme from '../stylesheets/theme';

import Layout from '../components/layout';

const VarausJaPeeruStyles = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .terms-container {
    margin: 150px auto 0;
    display: flex;
    flex-direction: column;
    max-width: 800px;
  }
`;

const VarausJaPeeru = () => (
  <Layout
    seo={{
      title: 'Discover Lapland - Rekisteri- ja tietosuojaseloste',
    }}
  >
    <ThemeProvider theme={theme}>
      <VarausJaPeeruStyles>
        <div className="terms-container">
          <h2>Rekisteri- ja tietosuojaseloste</h2>
          <br />
          <p>
            Tämä tietosuojaseloste kuvaa, miten Daily Race Oy / Discover Lapland
            käsittelee asiakkaidensa henkilötietoja.
          </p>
          <br />
          <p>Päivitetty 9.9.2026.</p>
          <br />
          <h3>1. Rekisterinpitäjä</h3>
          <br />
          <p>
            Daily Race Oy / Discover Lapland
            <br />
            Y-tunnus: 2232108-3
            <br />
            Onnenpolku 30 B
            <br />
            99130 Sirkka
          </p>
          <br />
          <h3>2. Yhteyshenkilö tietosuoja-asioissa</h3>
          <br />
          <p>
            Anette Latva-Piikkilä
            <br />
            Puhelin: 040 772 4124
            <br />
            Sähköposti:{' '}
            <a href="mailto:anettelatvapiikkila@gmail.com">
              anettelatvapiikkila@gmail.com
            </a>
          </p>
          <br />
          <h3>3. Rekisterin nimi</h3>
          <br />
          <p>Discover Laplandin asiakasrekisteri.</p>
          <br />
          <h3>4. Henkilötietojen käsittelyn tarkoitus ja oikeusperuste</h3>
          <br />
          <p>
            Henkilötietoja käsitellään asiakkaan ilmoittautumisen ja varauksen
            käsittelemiseksi, asiakassuhteen hoitamiseksi, vaelluksen
            järjestämiseksi sekä asiakkaan kanssa viestimiseksi.
          </p>
          <br />
          <p>
            Henkilötietojen käsittely perustuu pääasiassa asiakkaan kanssa
            tehtävän sopimuksen valmisteluun ja täytäntöönpanoon sekä
            rekisterinpitäjän lakisääteisten velvoitteiden hoitamiseen.
          </p>
          <br />
          <p>
            Vaelluksen turvallisuuden ja osallistujan soveltuvuuden
            arvioimiseksi asiakkaalta voidaan lisäksi pyytää tarpeellisia
            terveydentilaan tai aikaisempiin vammoihin liittyviä tietoja. Näiden
            tietojen käsittely perustuu asiakkaan nimenomaiseen suostumukseen.
          </p>
          <br />
          <p>
            Tietoja ei käytetä automatisoituun päätöksentekoon tai
            profilointiin.
          </p>
          <br />
          <h3>5. Käsiteltävät henkilötiedot</h3>
          <br />
          <p>Asiakasrekisterissä voidaan käsitellä seuraavia tietoja:</p>
          <ul>
            <li>nimi ja ikä</li>
            <li>
              yhteystiedot, kuten puhelinnumero, sähköpostiosoite ja paikkakunta
            </li>
            <li>varaukseen ja osallistumiseen liittyvät tiedot</li>
            <li>
              aikaisempaa vaellus-, hiihto- tai muuta olennaista kokemusta
              koskevat tiedot
            </li>
            <li>
              osallistujan itse ilmoittamat, vaelluksen turvallisuuden ja
              soveltuvuuden arvioinnin kannalta tarpeelliset tiedot
              terveydentilasta, toimintakyvystä ja aikaisemmista vammoista
            </li>
            <li>laskutukseen ja maksamiseen liittyvät tarpeelliset tiedot.</li>
          </ul>
          <br />
          <p>
            Terveydentilaa koskevia tietoja pyydetään ja käsitellään vain siinä
            laajuudessa kuin se on vaelluksen turvallisen toteuttamisen ja
            osallistujan soveltuvuuden arvioinnin kannalta tarpeellista.
          </p>
          <br />
          <h3>6. Henkilötietojen säilyttäminen</h3>
          <br />
          <p>
            Vaellukselle osallistumista, soveltuvuutta ja turvallisuutta varten
            kerättyjä tietoja säilytetään vain niin kauan kuin niitä tarvitaan
            vaelluksen järjestämiseen ja siihen välittömästi liittyvien asioiden
            hoitamiseen. Tarpeettomat tiedot, mukaan lukien terveydentilaa
            koskevat tiedot, poistetaan tämän jälkeen.
          </p>
          <br />
          <p>
            Laskutukseen, kirjanpitoon ja muihin lakisääteisiin velvoitteisiin
            liittyviä tietoja säilytetään lainsäädännön edellyttämän ajan.
          </p>
          <br />
          <p>
            Henkilötietoja ei säilytetä pidempään kuin niiden käyttötarkoitus
            tai lainsäädäntö edellyttää.
          </p>
          <br />
          <h3>7. Säännönmukaiset tietolähteet</h3>
          <br />
          <p>
            Henkilötiedot saadaan pääasiassa asiakkaalta itseltään sähköpostitse
            ja muun varaukseen liittyvän yhteydenpidon yhteydessä.
          </p>
          <br />
          <h3>8. Henkilötietojen luovuttaminen ja käsittelijät</h3>
          <br />
          <p>
            Henkilötietoja ei myydä eikä luovuteta ulkopuolisille
            markkinointitarkoituksiin.
          </p>
          <br />
          <p>
            Tietoja voivat käsitellä Daily Race Oy:n käyttämät palveluntarjoajat
            siinä määrin kuin se on esimerkiksi sähköpostin, verkkosivujen,
            laskutuksen, kirjanpidon tai muiden yrityksen käyttämien palvelujen
            toteuttamiseksi tarpeellista.
          </p>
          <br />
          <p>
            Tietoja voidaan lisäksi luovuttaa viranomaiselle, jos lainsäädäntö
            sitä edellyttää.
          </p>
          <br />
          <h3>9. Tietojen siirtäminen EU:n tai ETA:n ulkopuolelle</h3>
          <br />
          <p>
            Daily Race Oy ei itse säännönmukaisesti luovuta asiakkaiden
            henkilötietoja EU:n tai ETA:n ulkopuolelle.
          </p>
          <br />
          <p>
            Yrityksen käyttämät tietotekniset palveluntarjoajat voivat kuitenkin
            käsitellä tietoja EU:n tai ETA:n ulkopuolella. Tällöin
            henkilötietojen asianmukaisesta suojasta huolehditaan
            tietosuojalainsäädännön edellyttämällä tavalla.
          </p>
          <br />
          <h3>10. Rekisterin suojaaminen</h3>
          <br />
          <p>
            Henkilötietoja käsitellään huolellisesti ja luottamuksellisesti.
            Tiedot suojataan asianmukaisin teknisin ja organisatorisin
            toimenpitein asiattomalta pääsyltä, muuttamiselta, luovuttamiselta
            ja hävittämiseltä.
          </p>
          <br />
          <p>
            Henkilötietoihin on pääsy vain henkilöillä, joiden tehtävien
            hoitaminen sitä edellyttää.
          </p>
          <br />
          <h3>11. Rekisteröidyn oikeudet</h3>
          <br />
          <p>Rekisteröidyllä on tietosuojalainsäädännön mukaisesti oikeus:</p>
          <ul>
            <li>
              saada tietoa henkilötietojensa käsittelystä ja tarkastaa itseään
              koskevat tiedot
            </li>
            <li>
              pyytää virheellisten tai puutteellisten tietojen oikaisemista
            </li>
            <li>
              pyytää henkilötietojensa poistamista silloin, kun niiden
              käsittelylle ei enää ole laillista perustetta
            </li>
            <li>
              pyytää henkilötietojen käsittelyn rajoittamista tietyissä
              tilanteissa
            </li>
            <li>
              vastustaa henkilötietojen käsittelyä silloin, kun tähän on
              tietosuojalainsäädännön mukainen peruste
            </li>
            <li>
              saada itse toimittamansa tiedot siirretyksi järjestelmästä toiseen
              silloin, kun tähän soveltuvat GDPR:n edellytykset
            </li>
            <li>
              peruuttaa antamansa suostumus milloin tahansa silloin, kun
              henkilötietojen käsittely perustuu suostumukseen.
            </li>
          </ul>
          <br />
          <p>
            Suostumuksen peruuttaminen ei vaikuta ennen sen peruuttamista
            suoritetun käsittelyn lainmukaisuuteen.
          </p>
          <br />
          <p>
            Tietosuojaa koskevat pyynnöt voi lähettää sähköpostitse osoitteeseen{' '}
            <a href="mailto:anettelatvapiikkila@gmail.com">
              anettelatvapiikkila@gmail.com
            </a>
            . Rekisterinpitäjä voi tarvittaessa pyytää henkilöllisyyden
            varmistamista.
          </p>
          <br />
          <p>
            Rekisteröidyllä on lisäksi oikeus tehdä henkilötietojensa käsittelyä
            koskeva valitus Tietosuojavaltuutetun toimistolle.
          </p>
        </div>
      </VarausJaPeeruStyles>
    </ThemeProvider>
  </Layout>
);

export default VarausJaPeeru;
